import { supabase } from '@/lib/supabase';
import { formatProfileName } from '@/utils/profileHelpers';

export async function fetchProfileDisplayName(userId: string, fallback = 'A volunteer'): Promise<string> {
  const { data } = await supabase
    .from('profiles')
    .select('first_name, last_name')
    .eq('id', userId)
    .maybeSingle();
  if (!data) return fallback;
  return formatProfileName(data.first_name, data.last_name, fallback);
}

export function formatOrgDisplayName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  fallback = 'Organization',
): string {
  return formatProfileName(firstName, lastName, fallback);
}
